export default class VersaoApi {
    titulo: string;
    versao: string;
    build: string;
    offline: boolean;
}